import Maska from 'maska';

export default Maska;
